import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  CardHeader,
  Alert
} from 'reactstrap';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import SweetAlert from 'react-bootstrap-sweetalert';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { AvForm, AvField } from 'availity-reactstrap-validation';


class CountriesComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      selCountry: [],
      alert: null,
      countryModal: false,
      isEdit: false,
      countryColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          hidden: true,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Country',
          dataField: 'cntry_name',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cntr) => (
            <h5 className='font-size-16 mb-1 '>
              {cntr.cntry_name}
            </h5>
          )
        },
        {
          text: 'Code',
          dataField: 'cntry_code',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cntr) => (
            <h5 className='font-size-16 mb-1 '>{cntr.cntry_code}</h5>
          )
        },
        {
          text: 'Region',
          dataField: 'region',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cntr) => (
            <h5 className='font-size-16 mb-1 '>{cntr.region}</h5>
          )
        },
        {
          text: 'Responsible',
          dataField: 'responsible',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cntr) => (
            <h5 className='font-size-16 mb-1 '>{cntr.responsible.fname} {cntr.responsible.sname}</h5>
          )
        },
        {
          dataField: 'menu',
          text: 'Action',
          editable: false,
          formatter: (cellContent, cntr) => (
            <div className='text-center'>
              <Link className='text-success me-2' to='#'>
                <i
                  className='mdi mdi-pencil font-size-18'
                  id='edittooltip'
                  onClick={(e) => this.handleEditCountry(cntr)}
                ></i>
              </Link>
              <Link className='text-danger' to='#'>
                <i
                  className='mdi mdi-delete font-size-18'
                  id='deletetooltip'
                  onClick={() => this.handleDeleteCountry(cntr)}
                ></i>
              </Link>
            </div>
          )
        }
      ],
    }
    this.toggleCountryModal = this.toggleCountryModal.bind(this);
    this.handleNewCountry = this.handleNewCountry.bind(this);
    this.handleEditCountry = this.handleEditCountry.bind(this);
    this.checkExistingCountry = this.checkExistingCountry.bind(this);
    this.handleSubmitCountry = this.handleSubmitCountry.bind(this);
    this.handleDeleteCountry = this.handleDeleteCountry.bind(this)
  }
  toggleCountryModal = () => { this.setState((prevState) => ({ countryModal: !prevState.countryModal })); };
  /**
   * Open modal for new country
   */
  handleNewCountry = () => {
    this.setState({ selCountry: [], error: '', isEdit: false });
    this.toggleCountryModal();
  };
  /**
   * Assign selected country for editing
   * @param {*} country 
   */
  handleEditCountry = (country) => {
    this.setState({
      selCountry: {
        _id: country._id,
        cntry_code: country.cntry_code,
        cntry_name: country.cntry_name,
        region: country.region,
        responsible: country.responsible._id
      },
      error: '',
      isEdit: true
    });
    this.toggleCountryModal();
  };
  /**
   * Check if country is already exists in the table
   * @param {array} newCountry value with new battle invoice No
   * @returns true or false
   */
  checkExistingCountry = (newCountry) => {
    const { countries } = this.props.props;
    return countries.some(function (el) {
      return el.cntry_name === newCountry.cntry_name;
    });
  };
  /**
   * Submit new country row 
   * @param {*} e 
   * @param {*} values 
   */
  handleSubmitCountry = (e, values) => {
    const { onAddInfoData, onEditInfoData } = this.props.props;
    const { isEdit, selCountry } = this.state;
    if (isEdit) {
      const updateCountry = {
        type: 'countries',
        _id: selCountry._id,
        cntry_name: values.cntry_name,
        cntry_code: values.cntry_code,
        region: values.region,
        responsible: values.responsible,
      }
      onEditInfoData(updateCountry)
      this.toggleCountryModal();
    } else {
      const newCountry = {
        type: 'countries',
        cntry_name: values['cntry_name'],
        cntry_code: values['cntry_code'],
        region: values['region'],
        responsible: values['responsible'],
      }
      if (this.checkExistingCountry(newCountry) === true) {
        this.setState({
          error: 'Already exists.'
        });
      } else{
        onAddInfoData(newCountry)
        this.toggleCountryModal();
      }
    }
  };
  /**
   * Display delete alert
   * @param {*} country 
   */
  handleDeleteCountry = (country) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert({type: 'countries', id: country._id})}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Delete country row
   * @param {*} data 
   */
  deleteAlert = (data) => {
    const { onDeleteInfoData } = this.props.props;
    onDeleteInfoData(data);
    this.hideAlert();
  };
  /**
   * Hide alert
   * @returns 
   */
  hideAlert = () => this.setState({ alert: null });

  render() {
    const { SearchBar } = Search;
    const { countries, users } = this.props.props;
    const { countryColumns, countryModal, selCountry, error, alert, isEdit } = this.state;
    const pageOptions = {
      sizePerPage: countries?.length,
      totalSize: countries?.length, // replace later with size(users),
      custom: true
    };
    const defaultSorted = [
      {
        dataField: '_id', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];   
    return (
      <React.Fragment>
        <Card>
          <CardBody className='cardBodySticky'>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField='_id'
              columns={countryColumns}
              data={countries}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField='_id'
                  columns={countryColumns}
                  data={countries}
                  search
                >
                  {(toolkitprops) => (
                    <React.Fragment>
                      <Row className='mb-2'>
                        <Col sm='4'>
                          <div className='search-box ms-2 mt-3 mb-2 d-inline-block'>
                            <div className='position-relative'>
                              <SearchBar {...toolkitprops.searchProps} />
                              <i className='bx bx-search-alt search-icon' />
                            </div>
                          </div>
                        </Col>
                        <Col sm='8' className='text-sm-end'>
                          <Button color='primary' className='mt-2 btn-block btn btn-primary btn-lg' onClick={this.handleNewCountry}>
                            <i className='mdi mdi-plus-circle-outline me-1' />
                            Add New Country
                          </Button>
                          <Modal
                            size='md'
                            isOpen={countryModal}
                            className={this.props.className}
                            toggle={this.toggleCountryModal}
                          >
                            <ModalHeader toggle={this.toggleCountryModal} tag='h4'>
                              {!!isEdit ? 'Edit Country' : 'Add Country'}
                            </ModalHeader>
                            <ModalBody>
                              {error !== '' && error ? <Alert color='danger'> {error} </Alert> : null}
                              <AvForm onValidSubmit={this.handleSubmitCountry}>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='cntry_name'
                                        label='Country'
                                        value={selCountry.cntry_name || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='cntry_code'
                                        label='Code'
                                        value={selCountry.cntry_code || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        type='select'
                                        name='region'
                                        label='Region'
                                        className='form-select'
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                        value={ selCountry.region || '' }
                                      >
                                        <option value=''>Select Region</option>
                                        <option value='continent'>Continent</option>
                                        <option value='country'>Country</option>
                                        <option value='state'>State</option>
                                        <option value='city'>City</option>
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        type='select'
                                        name='responsible'
                                        label='Responsible'
                                        className='form-select'
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                        value={ selCountry.responsible || '' }
                                      >
                                        <option value=''>Select User</option>
                                        {users.length !== 0 && users.map((user, index) => {
                                          return (
                                            <option key={index} value={user._id}>
                                              {user.fname} {user.sname}
                                            </option>
                                          );
                                        })}
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className='text-end'>
                                      <button
                                        type='submit'
                                        className='btn btn-success save-user'
                                      >
                                        {!!isEdit
                                          ? 'Edit Country'
                                          : 'Add Country'}
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </ModalBody>
                          </Modal>
                        </Col>
                      </Row>
                      <Row id='table-section'>
                        <BootstrapTable
                          {...toolkitprops.baseProps}
                          {...paginationTableProps}
                          defaultSorted={defaultSorted}
                          classes={
                            'table align-middle text-center table-nowrap'
                          }
                          headerClasses='header-class is-sticky-hdr'
                          id='tableScroll'
                          bordered={true}
                          // striped={true}
                          responsive
                        />
                        {alert}
                      </Row>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

CountriesComp.propTypes = {

};

const mapStateToProps = ({ state }) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CountriesComp));